import { darken } from 'polished';
import styled, { css } from 'styled-components';

interface ContainerProps {
  height?: string;
  isFilled: boolean;
  isFocuses: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  border-radius: 4px;
  border: 1px solid rgba(221, 221, 221, 0.87);
  padding: 7px 8px;
  width: 100%;
  display: flex;
  align-items: center;

  + div {
    margin-top: 8px;
  }

  div {
    width: 100%;
    position: relative;

    .button-show {
      width: 70px;
      font-size: 12px;
      text-align: center;
      background: none;
      border: 0;
      padding: 6px 6px 6px;
      color: #fa8009 !important;
      height: 52px;
      font-weight: bold;
    }
  }

  input {
    width: 100%;
    flex: 1;
    background: transparent;
    border: 0;
    color: #5d5d5d;
    font-size: 12px;
    transition-duration: 0.2s;

    ::placeholder {
      color: #d3d3d3;
    }

    :focus {
      border: none;
      outline: 0;
    }

    :disabled {
      opacity: 0.7;
    }
  }

  .rotate-arrow {
  }

  .options {
    border-radius: 0 0 4px 4px;
    background-color: #fff;
    border: 1px solid #d3d3d3;
    width: calc(100% + 2px);
    left: -1px;
    top: 35px;
    max-height: 200px;
    overflow: auto;
    z-index: 100;

    button {
      border: none;
      border-bottom: 1px solid #d3d3d3;
      background: transparent;
      transition-duration: 0.3s;
      color: #5d5d5d;
      font-size: 12px;
      min-height: 35px;

      :hover {
        background-color: ${darken(0.02, '#ffffff')};
      }
    }
  }

  .btn-orange {
    background-color: #fa8009 !important;
    color: #fff !important;

    :hover {
      background-color: ${darken(0.05, '#fa8009')} !important;
    }
  }

  svg {
    color: #8692a6;
    transition-duration: 0.2s;
    pointer-events: none;
  }

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #c53030;
    `}

  ${(props) => props.isFilled && css``}

  ${(props) =>
    props.isFocuses &&
    css`
      /* color: #606060;
      border-color: #606060; */
      border-radius: 4px 4px 0 0 !important;
      svg {
        transform: rotate(180deg);
      }
    `}
`;
